export const InternalOpsRequests = [
    {
        request_type: 'Add New Supplier',
        label: 'Add New Supplier',
        value: 'add_supplier',
        categories: [],
    },
    {
        request_type: 'Add New Buyer',
        label: 'Add New Buyer',
        value: 'add_buyer',
        categories: [],
    },
    {
        request_type: 'Add New Investor',
        label: 'Add New Investor',
        value: 'add_investor',
        categories: [],
    },
    {
        request_type: 'Amend BDN',
        label: 'Amend BDN',
        value: 'bdn',
        categories: [
            {
                value: 'mismatch_info_with_deal_summary',
                label: 'Mismatch info with deal summary - need confirmation',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Buyer PO',
        label: 'Amend Buyer PO',
        value: 'buyer_po',
        categories: [
            {
                value: 'incorrect_information',
                label: 'Incorrect information',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Buyer Invoice',
        label: 'Amend Buyer Invoice',
        value: 'buyer_invoice',
        categories: [
            {
                value: 'address',
                label: 'Address',
            },
            {
                value: 'delivery_date',
                label: 'Delivery date',
            },
            {
                value: 'due_date',
                label: 'Due date',
            },
            {
                value: 'unit_price',
                label: 'Unit Price',
            },
            {
                value: 'qty',
                label: 'QTY',
            },
            {
                value: 'invoice_amount',
                label: 'Invoice Amount',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Buyer Payment Confirmation',
        label: 'Amend Buyer Payment Confirmation',
        value: 'amend_buyer_payment_confirmation',
        categories: [
            {
                value: 'address',
                label: 'Address',
            },
            {
                value: 'due_date',
                label: 'Due date',
            },
            {
                value: 'currency',
                label: 'Currency',
            },
            {
                value: 'amount',
                label: 'Amount',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Supplier Invoice',
        label: 'Amend Supplier Invoice',
        value: 'supplier_invoice',
        categories: [
            {
                value: 'address',
                label: 'Address',
            },
            {
                value: 'due_date',
                label: 'Due date',
            },
            {
                value: 'currency',
                label: 'Currency',
            },
            {
                value: 'amount',
                label: 'Amount',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Supplier Payment Confirmation',
        label: 'Amend Supplier Payment Confirmation',
        value: 'supplier_payment_confirmation',
        categories: [
            {
                value: 'first_payment',
                label: 'First Payment',
                sub_categories: [
                    {
                        value: 'address',
                        label: 'Address',
                    },
                    {
                        value: 'due_date',
                        label: 'Due date',
                    },
                    {
                        value: 'currency',
                        label: 'Currency',
                    },
                    {
                        value: 'amount',
                        label: 'Amount',
                    },
                    {
                        value: 'other',
                        label: 'Other',
                    },
                ],
            },
            {
                value: 'second_payment',
                label: 'Second Payment',
                sub_categories: [
                    {
                        value: 'address',
                        label: 'Address',
                    },
                    {
                        value: 'due_date',
                        label: 'Due date',
                    },
                    {
                        value: 'currency',
                        label: 'Currency',
                    },
                    {
                        value: 'amount',
                        label: 'Amount',
                    },
                    {
                        value: 'other',
                        label: 'Other',
                    },
                ],
            },
        ],
    },
    {
        request_type: 'Amend Supplier SO',
        label: 'Amend Supplier SO',
        value: 'supplier_so',
        categories: [
            {
                value: 'incorrect_information',
                label: 'Incorrect information',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Delete User Profile Request',
        label: 'Delete User Profile Request',
        value: 'delete_profile',
        categories: [
            {
                value: 'buyer',
                label: 'Buyer',
            },
            {
                value: 'supplier',
                label: 'Supplier',
            },
            {
                value: 'investor',
                label: 'Investor',
            },
        ],
    },
    {
        request_type: 'Update Facility Linking',
        label: 'Update Facility Linking',
        value: 'facility_linking',
        categories: [],
    },
    {
        request_type: 'Set Buyer Credit',
        label: 'Set Buyer Credit',
        value: 'set_buyer_credit',
        categories: [],
    },
];
